import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { PageListModule } from './page-list';
import { EditPageModule } from './edit-page';

import { ROUTES } from './page.routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    TranslateModule,
    PageListModule,
    EditPageModule
  ]
})
export class PageModule {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+page/page.module.ts